/* Homentum, Crăciun 2026 (macheta D): bradul, poveștile, fulgii și biscuiții, colțurile de ușă. Fără dependențe. */
(function () {
  'use strict';
  var fmt = function (cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v.replace(/,00$/, '') + ' lei';
  };

  /* ---------- bradul (macheta D) ---------- */
  /* One tree per page. Any [data-hmb-add] button with a data-hmb-item JSON {key,id,name,price(bani),img} puts a piece in it,
     so the stories, snowflakes and biscuits sections reuse the same tree. Chosen pieces survive a reload (sessionStorage). */
  var root = document.querySelector('[data-hmb]');
  if (!root) return;
  var q = function (sel) { return root.querySelector(sel); };
  var slots = Array.prototype.slice.call(root.querySelectorAll('[data-hmb-slot]'));
  var max = Math.max(slots.length, +root.getAttribute('data-hmb-max') || 0);
  var showEmpty = +root.getAttribute('data-hmb-show') || 7;
  var moreEl = root.querySelector('[data-hmb-more]');
  var tiers = [];
  try { tiers = JSON.parse(root.getAttribute('data-hmb-tiers')) || []; } catch (e) {}
  tiers.sort(function (a, b) { return a.qty - b.qty; });
  var free = +root.getAttribute('data-hmb-free') || 0;
  var bars = Array.prototype.slice.call(root.querySelectorAll('[data-hmb-bar]'));
  var countEl = q('[data-hmb-count]'), subEl = q('[data-hmb-sub]'), totEl = q('[data-hmb-total]'), msgEl = q('[data-hmb-msg]');
  var shipEl = q('[data-hmb-ship]'), pages = q('[data-hmb-pages]');
  var cartBtns = Array.prototype.slice.call(root.querySelectorAll('[data-hmb-cart]'));
  var bar = q('[data-hmb-bar-sticky]'), calc = q('.hmb__calc'), calcVisible = false;
  var KEY = 'hmb-brad-v1';
  var chosen = [];
  try { chosen = JSON.parse(sessionStorage.getItem(KEY)) || []; } catch (e) {}
  chosen = chosen.filter(function (c) { return c && c.id && c.price; }).slice(0, max);
  var plural = function (n, one, many) { return n + (n === 1 ? ' ' + one : ' ' + many); };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };

  function tierFor(n) { var t = null; tiers.forEach(function (x) { if (n >= x.qty) t = x; }); return t; }
  function nextTier(n) { for (var i = 0; i < tiers.length; i++) if (tiers[i].qty > n) return tiers[i]; return null; }
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(chosen)); } catch (e) {} }

  function render(popIndex) {
    var n = chosen.length;
    slots.forEach(function (s, k) {
      var c = chosen[k];
      if (!c) { s.removeAttribute('data-key'); s.innerHTML = k < showEmpty ? '<div class="hmb__empty" aria-hidden="true"></div>' : ''; return; }
      if (s.getAttribute('data-key') === c.key + k && popIndex !== k) return;
      s.innerHTML = '<button type="button" class="hmb__hang' + (popIndex === k ? ' hmb__hang--in' : '') + '" aria-label="Scoate ' + esc(c.name) + ' din brad">' +
        '<span class="hmb__thread"></span><img src="' + esc(c.img) + '" alt=""></button>';
      s.setAttribute('data-key', c.key + k);
      s.firstChild.addEventListener('click', function () { chosen.splice(k, 1); slots.forEach(function (x) { x.removeAttribute('data-key'); }); save(); render(); });
    });
    var counts = {};
    chosen.forEach(function (c) { counts[c.key] = (counts[c.key] || 0) + 1; });
    document.querySelectorAll('[data-hmb-add]').forEach(function (b) {
      var badge = (b.closest('[data-hmb-card]') || b).querySelector('[data-hmb-badge]'); if (!badge) return;
      var it; try { it = JSON.parse(b.getAttribute('data-hmb-item')); } catch (e) { return; }
      var k = counts[it.key] || 0; badge.hidden = !k; badge.textContent = k;
    });
    if (moreEl) { var extra = n - slots.length; moreEl.hidden = extra <= 0; moreEl.textContent = '+' + extra + (extra === 1 ? ' piesă' : ' piese') + ' în brad'; }
    var sub = chosen.reduce(function (a, c) { return a + c.price; }, 0);
    var t = tierFor(n), nt = nextTier(n);
    var tot = t ? Math.round(sub * (100 - t.pct) / 100) : sub;
    bars.forEach(function (b, i) { b.classList.toggle('on', n > i); });
    countEl.textContent = 'Bradul tău · ' + plural(n, 'piesă', 'piese');
    var hint = q('[data-hmb-hint]'); if (hint) hint.textContent = hint.getAttribute(n && !root.hasAttribute('data-hmb-gift-on') ? 'data-started' : 'data-empty');
    subEl.hidden = !t; subEl.textContent = fmt(sub);
    totEl.textContent = fmt(tot);
    if (n === 0) msgEl.textContent = 'Atinge un ornament ca să-l pui în brad.';
    else if (nt) msgEl.textContent = 'Mai pui ' + plural(nt.qty - n, 'piesă', 'piese') + ' și ai ' + nt.pct + '% mai puțin.';
    else if (t) msgEl.textContent = 'Ai prețul de set maxim: ' + t.pct + '% mai puțin.';
    shipEl.textContent = !free ? '' : (tot >= free ? 'Livrare gratuită' : 'Încă ' + fmt(free - tot) + ' până la livrare gratuită');
    cartBtns.forEach(function (b) { b.disabled = n === 0; });
    if (bar) {
      q('[data-hmb-bar-count]').textContent = countEl.textContent;
      var bs = q('[data-hmb-bar-sub]'); bs.hidden = !t; bs.textContent = fmt(sub);
      q('[data-hmb-bar-total]').textContent = fmt(tot);
      showBar();
    }
  }
  function showBar() {
    if (!bar) return;
    var on = chosen.length > 0 && !calcVisible;
    bar.hidden = !on; document.body.classList.toggle('hmb-bar-on', on);
  }
  if (bar && calc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { calcVisible = es[0].isIntersecting; showBar(); }, { threshold: 0.2 }).observe(calc);
  }

  function add(it, btn) {
    if (!it || !it.id) return false;
    if (chosen.length >= max) {
      msgEl.textContent = 'Ai ' + max + ' piese în brad, cât încape într-o comandă de aici. Pune-le în coș și continuă.';
      root.classList.add('hmb--shake'); setTimeout(function () { root.classList.remove('hmb--shake'); }, 400);
      document.dispatchEvent(new CustomEvent('hmb:full', { detail: { item: it, button: btn, max: max } }));
      return false;
    }
    chosen.push({ key: it.key, id: it.id, name: it.name, price: it.price, img: it.img });
    save(); render(chosen.length - 1);
    document.dispatchEvent(new CustomEvent('hmb:added', { detail: { item: it, button: btn } }));
    return true;
  }
  window.hmbBrad = {
    add: add,
    refresh: function () { render(); },
    items: function () { return chosen.slice(); },
    set: function (list) { chosen = list.slice(0, max); slots.forEach(function (x) { x.removeAttribute('data-key'); }); save(); render(); }
  };

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hmb-add]'); if (!b) return;
    var it; try { it = JSON.parse(b.getAttribute('data-hmb-item')); } catch (err) { return; }
    add(it, b);
  });
  q('[data-hmb-clear]').addEventListener('click', function () { chosen = []; save(); render(); });
  var step = function (dir) { pages.scrollBy({ left: dir * pages.clientWidth, behavior: 'smooth' }); };
  q('[data-hmb-prev]').addEventListener('click', function () { step(-1); });
  q('[data-hmb-next]').addEventListener('click', function () { step(1); });

  function toCart(btn) {
    if (!chosen.length) return;
    var qty = {}, order = [];
    chosen.forEach(function (c) { if (!qty[c.id]) order.push(c.id); qty[c.id] = (qty[c.id] || 0) + 1; });
    var old = btn.textContent;
    cartBtns.forEach(function (b) { b.disabled = true; });
    btn.textContent = 'Se pune în coș…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: order.map(function (id) { return { id: id, quantity: qty[id] }; }) }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        chosen = []; save();
        btn.textContent = 'E în coș ✓';
        setTimeout(function () { window.location.href = '/cart'; }, 350);
      })
      .catch(function () { cartBtns.forEach(function (b) { b.disabled = false; }); btn.textContent = old; msgEl.textContent = 'Nu am putut pune bradul în coș. Încearcă din nou.'; });
  }
  cartBtns.forEach(function (b) { b.addEventListener('click', function () { toCart(b); }); });
  render();
})();

/* ---------- „26 de povești de agățat în brad” (macheta D) ---------- */
(function () {
  'use strict';
  var root = document.querySelector('[data-hmp]');
  if (!root) return;
  var q = function (sel) { return root.querySelector(sel); };
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hmp-card]'));
  var filters = Array.prototype.slice.call(root.querySelectorAll('[data-hmp-filters] button'));
  var allBtn = q('[data-hmp-all]'), story = q('[data-hmp-story]'), addBtn = q('[data-hmp-add]'), done = q('[data-hmp-done]');
  /* „Toate”: 8 la început (6 pe telefon), apoi câte 8 la fiecare „Arată încă” */
  var small = window.matchMedia('(max-width: 760px)').matches;
  var state = { theme: '', shown: small ? 6 : 8 };
  var STEP = 8;

  function show() {
    cards.forEach(function (c) {
      var hide = state.theme ? c.getAttribute('data-theme') !== state.theme : cards.indexOf(c) >= state.shown;
      (c.closest('.hmp__cell') || c).hidden = hide;
    });
    var left = cards.length - state.shown;
    if (allBtn) {
      allBtn.parentNode.hidden = !!state.theme || left <= 0;
      var k = Math.min(STEP, left);
      allBtn.textContent = 'Arată încă ' + k + (k === 1 ? ' ornament' : (k < 20 ? ' ornamente' : ' de ornamente'));
    }
    filters.forEach(function (f) { var on = f.getAttribute('data-theme') === state.theme; f.classList.toggle('is-on', on); f.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }
  function pick(c) {
    cards.forEach(function (x) { x.classList.toggle('is-on', x === c); });
    var img = q('[data-hmp-img]');
    img.src = c.getAttribute('data-img'); img.alt = 'Ornamentul ' + c.getAttribute('data-name') + ' în brad';
    var cut = q('[data-hmp-cut]'); if (cut && c.getAttribute('data-cut')) cut.src = c.getAttribute('data-cut');
    q('[data-hmp-name]').textContent = c.getAttribute('data-name');
    q('[data-hmp-text]').textContent = c.getAttribute('data-story');
    q('[data-hmp-who]').textContent = c.getAttribute('data-who');
    q('[data-hmp-price]').textContent = c.getAttribute('data-price');
    q('[data-hmp-url]').href = c.getAttribute('data-url');
    addBtn.setAttribute('data-hmb-item', c.getAttribute('data-item'));
    done.textContent = '';
    var r = story.getBoundingClientRect();
    if (r.top < 0 || r.top > window.innerHeight * 0.6) story.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  cards.forEach(function (c) { c.addEventListener('click', function () { pick(c); }); });
  filters.forEach(function (f) { f.addEventListener('click', function () { state.theme = f.getAttribute('data-theme'); show(); }); });
  if (allBtn) allBtn.addEventListener('click', function () { state.shown += STEP; show(); });
  var say = function (html) { done.innerHTML = html; };
  document.addEventListener('hmb:added', function (e) {
    if (e.detail.button !== addBtn) return;
    say(e.detail.item.name + ' a intrat în brad. <a href="#brad">Vezi bradul</a>');
  });
  document.addEventListener('hmb:full', function (e) {
    if (e.detail.button !== addBtn) return;
    say('Ai ' + e.detail.max + ' piese în brad. <a href="#brad">Pune-le în coș</a> și continuă.');
  });
  show();
})();

/* ---------- „Și ceva mic lângă ele”: fulgi (culoare, apoi model) și biscuiți (macheta D) ---------- */
(function () {
  'use strict';
  var root = document.querySelector('[data-hmm]');
  if (!root) return;
  var toast = root.querySelector('[data-hmm-toast]'), timer;
  var colorBtns = Array.prototype.slice.call(root.querySelectorAll('[data-hmm-colors] button'));
  var flakes = Array.prototype.slice.call(root.querySelectorAll('[data-hmm-flake]'));
  var slug = function (t) { return t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-'); };
  var color = colorBtns.length ? colorBtns[0].getAttribute('data-color') : '';

  function setColor(c) {
    color = c;
    colorBtns.forEach(function (b) { var on = b.getAttribute('data-color') === c; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    flakes.forEach(function (f) {
      var vs = {}; try { vs = JSON.parse(f.getAttribute('data-variants')); } catch (e) {}
      var model = f.getAttribute('data-model');
      var imgs = {}; try { imgs = JSON.parse(f.getAttribute('data-imgs')); } catch (e) {}
      var src = imgs[c] || f.getAttribute('data-img');
      var im = f.querySelector('img'); if (im && im.getAttribute('src') !== src) im.src = src;
      var item = vs[c] ? { key: 'f-' + f.getAttribute('data-slug') + '-' + slug(c), id: vs[c], name: 'Fulgul ' + model + ' (' + c.toLowerCase() + ')', price: vs._price, img: src } : {};
      var plus = f.querySelector('[data-hmb-add]'), link = f.querySelector('a');
      plus.setAttribute('data-hmb-item', JSON.stringify(item));
      plus.disabled = !vs[c];
      plus.setAttribute('aria-label', 'Pune fulgul ' + model + ' ' + c.toLowerCase() + ' în brad');
      if (link && vs[c]) link.href = f.getAttribute('data-url') + '?variant=' + vs[c];
    });
    if (window.hmbBrad) window.hmbBrad.refresh();
  }
  colorBtns.forEach(function (b) { b.addEventListener('click', function () { setColor(b.getAttribute('data-color')); }); });
  var row = root.querySelector('[data-hmm-row]');
  var scroll = function (dir) { if (row) row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: 'smooth' }); };
  var prev = root.querySelector('[data-hmm-prev]'), next = root.querySelector('[data-hmm-next]');
  if (prev) prev.addEventListener('click', function () { scroll(-1); });
  if (next) next.addEventListener('click', function () { scroll(1); });
  function say(html) {
    toast.innerHTML = html; toast.hidden = false;
    clearTimeout(timer); timer = setTimeout(function () { toast.hidden = true; }, 4000);
  }
  /* the page-wide confirmation: every „+” outside the tree section (the story panel has its own line) */
  document.addEventListener('hmb:added', function (e) {
    var b = e.detail.button;
    if (!b || b.closest('[data-hmb]') || b.hasAttribute('data-hmp-add')) return;
    say(e.detail.item.name + ' a intrat în brad. <a href="#brad">Vezi bradul</a>');
  });
  document.addEventListener('hmb:full', function (e) {
    if (!e.detail.button || !root.contains(e.detail.button)) return;
    say('Ai ' + e.detail.max + ' piese în brad. <a href="#brad">Pune-le în coș</a> și continuă.');
  });
  setColor(color);
})();

/* ---------- colțurile de ușă: latura aleasă pe card (macheta D, structura seturilor) ---------- */
(function () {
  'use strict';
  document.querySelectorAll('[data-hmu]').forEach(function (card) {
    var sides = Array.prototype.slice.call(card.querySelectorAll('.hmu__side'));
    var id = card.querySelector('[data-hmu-id]'), price = card.querySelector('[data-hmu-price]');
    sides.forEach(function (b) {
      b.addEventListener('click', function () {
        sides.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
        id.value = b.getAttribute('data-id'); price.textContent = b.getAttribute('data-price');
      });
    });
  });
})();

/* ---------- „Trimite-i bradul tău” (21 oct, Cosmin): link cu piesele + prenumele opțional; cine îl primește vede bradul refăcut ---------- */
(function () {
  'use strict';
  var root = document.querySelector('[data-hmb]'), box = document.querySelector('[data-hmb-share]');
  if (!root || !box || !window.hmbBrad) return;
  var q = function (s) { return document.querySelector(s); };
  var open = q('[data-hmb-share-open]'), panel = q('[data-hmb-share-panel]'), nameIn = q('[data-hmb-share-name]');
  var send = q('[data-hmb-share-send]'), msg = q('[data-hmb-share-msg]');
  var plural = function (n) { return n + (n === 1 ? ' piesă' : ' piese'); };

  /* every piece the page can put in the tree, by variant id (flakes: every colour) */
  function registry() {
    var reg = {};
    document.querySelectorAll('[data-hmb-item]').forEach(function (b) {
      try { var it = JSON.parse(b.getAttribute('data-hmb-item')); if (it && it.id) reg[it.id] = it; } catch (e) {}
    });
    document.querySelectorAll('[data-hmm-flake]').forEach(function (f) {
      var vs = {}, imgs = {};
      try { vs = JSON.parse(f.getAttribute('data-variants')); imgs = JSON.parse(f.getAttribute('data-imgs')); } catch (e) { return; }
      Object.keys(vs).forEach(function (c) {
        if (c.charAt(0) === '_') return;
        var slug = c.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-');
        reg[vs[c]] = { key: 'f-' + f.getAttribute('data-slug') + '-' + slug, id: vs[c], name: 'Fulgul ' + f.getAttribute('data-model') + ' (' + c.toLowerCase() + ')', price: vs._price, img: imgs[c] || f.getAttribute('data-img') };
      });
    });
    return reg;
  }

  /* sender: brad=ID.ID.ID (repeats keep the order of the tree), de=prenume */
  function link() {
    var u = new URL(location.origin + location.pathname);
    var p = new URLSearchParams(location.search).get('preview_theme_id');
    if (p) u.searchParams.set('preview_theme_id', p);
    u.searchParams.set('brad', window.hmbBrad.items().map(function (c) { return c.id; }).join('.'));
    var n = (nameIn.value || '').replace(/[<>]/g, '').trim().slice(0, 30);
    if (n) u.searchParams.set('de', n);
    u.searchParams.set('utm_source', 'trimite-bradul');
    u.hash = 'brad';
    return u.toString();
  }
  var update = function () { open.disabled = window.hmbBrad.items().length === 0; if (open.disabled) { panel.hidden = true; } };
  document.addEventListener('hmb:added', update);
  root.addEventListener('click', function () { setTimeout(update, 0); });
  update();
  open.addEventListener('click', function () { panel.hidden = !panel.hidden; msg.textContent = ''; if (!panel.hidden) nameIn.focus(); });
  send.addEventListener('click', function () {
    var url = link(), text = box.getAttribute('data-text');
    var touch = window.matchMedia('(pointer: coarse)').matches;
    if (navigator.share && touch) {
      navigator.share({ title: document.title, text: text, url: url }).catch(function () {});
      return;
    }
    var done = function () { msg.textContent = box.getAttribute('data-copied'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text + ' ' + url).then(done, function () { window.prompt('Copiază linkul:', url); });
    else window.prompt('Copiază linkul:', url);
  });

  /* receiver */
  var params = new URLSearchParams(location.search), ids = (params.get('brad') || '').split('.').filter(Boolean);
  if (!ids.length) return;
  var reg = registry();
  var list = ids.map(function (id) { return reg[id]; }).filter(Boolean).slice(0, 60);
  if (!list.length) return;
  var who = (params.get('de') || '').replace(/[<>]/g, '').trim().slice(0, 30);
  var gift = q('[data-hmb-gift]'), text = q('[data-hmb-gift-text]'), actions = q('[data-hmb-gift-actions]');
  text.textContent = (who ? box.getAttribute('data-gift-named').replace('[nume]', who) : box.getAttribute('data-gift-anon')).replace('[n]', plural(list.length));
  gift.hidden = false;
  var mine = window.hmbBrad.items();
  var same = mine.length === list.length && mine.every(function (c, i) { return String(c.id) === String(list[i].id); });
  var clean = function () { params.delete('brad'); params.delete('de'); var qs = params.toString(); history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash); };
  if (!mine.length || same) { root.setAttribute('data-hmb-gift-on', ''); window.hmbBrad.set(list); clean(); }
  else {
    actions.hidden = false;
    q('[data-hmb-gift-use]').addEventListener('click', function () { root.setAttribute('data-hmb-gift-on', ''); window.hmbBrad.set(list); actions.hidden = true; clean(); });
    q('[data-hmb-gift-keep]').addEventListener('click', function () { gift.hidden = true; clean(); });
  }
  update();
  setTimeout(function () { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
})();

/* ---------- pagina de produs de Crăciun (21 oct, macheta D) ---------- */
(function () {
  'use strict';
  var root = document.querySelector('[data-hmpd]');
  if (!root) return;
  var q = function (s) { return root.querySelector(s); };
  var data = {}; try { data = JSON.parse(q('[data-hmpd-data]').textContent); } catch (e) { return; }
  var product = data.product || {}, variants = product.variants || [];
  var money = function (c) { return (c / 100).toFixed(2).replace('.', ',').replace(/,00$/, '') + ' lei'; };
  var slug = function (t) { return String(t).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
  var idIn = q('[data-hmpd-id]'), priceEl = q('[data-hmpd-price]'), cartBtn = q('[data-hmpd-cart]'), main = q('[data-hmpd-main]');
  var opts = Array.prototype.slice.call(root.querySelectorAll('[data-hmpd-opt]'));
  var current = variants.filter(function (v) { return String(v.id) === String(idIn.value); })[0] || variants[0];
  var sized = function (src, w) { return src ? src.replace(/(\?.*)?$/, function (m) { return (m && m.length ? m + '&' : '?') + 'width=' + w; }) : src; };

  function selected() { return opts.map(function (o) { var b = o.querySelector('.is-on'); return b ? b.getAttribute('data-val') : null; }); }
  // aceleași lățimi ca în secțiune, ca telefonul să nu ia 1200 px nici după schimbarea pozei
  function setMain(src) {
    if (!main || !src) return;
    var base = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    main.srcset = [500, 700, 900, 1200].map(function (w) { return sized(base, w) + ' ' + w + 'w'; }).join(', ');
    main.src = sized(base, 900);
  }
  function apply() {
    var vals = selected();
    var v = variants.filter(function (x) { return x.options.every(function (o, i) { return vals[i] === null || o === vals[i]; }); })[0];
    if (!v) return;
    current = v; idIn.value = v.id;
    priceEl.textContent = money(v.price);
    cartBtn.disabled = !v.available;
    opts.forEach(function (o, i) { var l = o.querySelector('[data-hmpd-optval]'); if (l) l.textContent = vals[i]; });
    var fi = v.featured_image || (variants.filter(function (x) { return x.options[0] === v.options[0] && x.featured_image; })[0] || {}).featured_image;
    if (fi) {
      setMain(fi.src);
      root.querySelectorAll('.hmpd__thumb').forEach(function (t) { t.classList.toggle('is-on', String(t.getAttribute('data-id')) === String(fi.id)); });
    }
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    /* flake chips take the chosen colour */
    if (data.isFlake && data.cuts) {
      var color = slug(vals[1] || '');
      root.querySelectorAll('.hmpd__chip').forEach(function (c) { var s = data.cuts[c.getAttribute('data-slug') + '-' + color]; var im = c.querySelector('img'); if (s && im) im.src = s; });
    }
  }
  opts.forEach(function (o) {
    o.querySelectorAll('[data-val]').forEach(function (b) {
      b.addEventListener('click', function () {
        o.querySelectorAll('[data-val]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
        apply();
      });
    });
  });
  root.querySelectorAll('.hmpd__thumb').forEach(function (t) {
    t.addEventListener('click', function () { root.querySelectorAll('.hmpd__thumb').forEach(function (x) { x.classList.toggle('is-on', x === t); }); setMain(t.getAttribute('data-src')); });
  });
  if (opts.length) apply();

  /* reviews: hidden while there are none; the line opens Judge.me's form */
  var ask = q('[data-hmpd-review]');
  if (ask) ask.addEventListener('click', function () {
    document.body.classList.add('hmpd-show-reviews');
    var w = document.querySelector('.jdgm-widget, .jdgm-review-widget, [id*="__178638510259382921"]');
    if (w) w.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(function () { var l = document.querySelector('.jdgm-write-rev-link'); if (l) l.click(); }, 700);
  });
})();
